export const headerEtat = {
    title: 'Etat',
    submodules: [
        createData(0, "MonthlyReport", "/monthlyreport"),
        createData(1, "LeavePerSemester", "/users"),
        createData(2, "leavepersemester", "/privileges"),
        createData(3, "PlanningPerSemester", "/planningpersemester"),
        createData(4, "ListLeaveReal", "/listleavereal"),
        createData(5, "ListLeavesPlanning", "/listleaveplanning"),
        createData(6, "Balancehistory", "/balancehistory")
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref};
}

